<template>
    <div class="is-width-100 is-height-fit m-0 is-flex is-flex-direction-column has-gap-medium">
        <div
            v-if="!hideHeader"
            class="box-title bloc m-0"
        >
            Order Placed {{ getDateCreated(order.dateCreated) }}
        </div>

        <div class="is-flex is-flex-direction-column has-gap-large is-width-100">
            <div class="is-flex is-align-items-center has-gap-medium is-size-4" v-for="item in order.lineItems">
                <div style="width: fit-content; height: fit-content;">
                    <LoadingImg :src="item.imageUrl" class="item-thumb" width="100" height="100" />
                </div>
                <div class="is-flex is-flex-direction-column">
                    <div>{{ item.name }}</div>
                    <div class="is-size-6 mt-1">x{{ item.quantity }}</div>
                </div>
            </div>
        </div>

        <div
            v-if="!hideFooter"
            class="block is-flex is-align-items-baseline is-size-6 is-flex-wrap-wrap"
            style="row-gap: .5rem; column-gap: 3rem;"
        >
            <div>Total: ${{ getTotalCost(order) }}</div>
            <div class="is-capitalized">Status: {{ order.status }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import LoadingImg from "@/Components/LoadingImg.vue";
import { Order } from "@/Types/Order";

const props = defineProps<{
    order: Order;
    hideHeader?: boolean;
    hideFooter?: boolean;
}>();

function getDateCreated(date: string) {
    return new Date(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

function getTotalCost(order: Order) {
    return (order.subtotal + order.salesTax).toFixed(2);
}
</script>
